module.exports = __webpack_public_path__ + "img/send.65b29c4c.png";